import {
  Menu,
  MenuItem,
  FormControlLabel,
  Divider,
  Grid2,
  IconButton,
  Tooltip,
  Checkbox,
  Collapse
} from "@mui/material";
import MaterialBox from "../../../../components/MaterialBox";
import MaterialTypography from "../../../../components/MaterialTypography";
import { ExpandMore, FilterAltOff } from "@mui/icons-material";
import { useLoading } from "../../../../components/Loading";
import { useEffect, useState } from "react";
import { useSnackbar } from "../../../../context/popup";
import { fetchData } from "../../../../services";


const StateListFilterDialog = ({ anchorEl, open, onClose, filterData, setFilterData, onApply }) => {

    const {setCircleLoading} = useLoading();
    const {showSnackbar} = useSnackbar();
    const [countryOptions, setCountryOptions] = useState([]);
    
    const [openActive, setOpenActive] = useState(false);
    const [openCountry, setOpenCountry] = useState(false);

    const sectionHeader = {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "6px 8px",
        background: "#e9ecf5",
        borderRadius: "6px",
        cursor: "pointer",
        mb: 0.5,
    };

    const menuItemStyle = {
        borderRadius: "6px",
        my: 0.2,
        mx: 0.5,
        py: 0.3,
        "&:hover": { backgroundColor: "#dfe6ff" },
    };

    const labelStyle = {
        m: 0,
        "& .MuiFormControlLabel-label": { fontSize: "0.8rem" },
    };

    useEffect(() => {
        if(!open){
            return;
        }
        fetchCountryList();
    },[open]);

    const fetchCountryList = async () => {
        setCircleLoading(true);
        try {
            const response = await fetchData(`/reference/general/country?dropdown=true&isActive=true`)

            if(response?.success){
                const formattedCountries = response?.data?.items?.map((item) => ({
                    value: item.id,
                    label: item.displayName,
                }));
                setCountryOptions(formattedCountries)
            }
            else{
                //throw error
                showSnackbar("Error Fetching Country List", "error")
            }
        } catch (error) {
            console.error('Error Fetching Countries:', error);
            showSnackbar("Error Fetching Country List", "error")
        }
        finally{
            setCircleLoading(false);
        }
    };

    const handleChange = ({ target: { name, value } }) => {
        setFilterData(prev => ({
            ...prev,
            [name]: value
        }));
    };


    const onClearFilters = () => {
        setFilterData({
            isActive: "",
            countryId: "",
        });
    };


  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      sx={{backgroundColor: "rgba(0, 0, 0, 0.3)",}}
      PaperProps={{
          elevation: 3,
          sx: {
            width: 220,
            padding: 1.5,
          },
      }}
    >
        <MaterialBox
        sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",             
        }}
        >
            {/* Title */}
            <MaterialTypography variant="body2" fontWeight="bold">
                State Filter
            </MaterialTypography>

            {/* Clear Button */}
            <Tooltip title="Clear Filter" disableInteractive>
                <IconButton
                    size="small"
                    onClick={onClearFilters}
                    sx={{ color: "#ce0707ff" }}
                >
                    <FilterAltOff />
                </IconButton>
            </Tooltip>
        </MaterialBox>


      {/* Content */}
        <MaterialBox ml={1} mt={1} sx={{
            maxHeight: 300, 
            overflowY: "auto"}}>
            <Grid2 container spacing={1}>
                <Grid2 size={{ xs: 12 }}>
                    <MaterialBox sx={sectionHeader} onClick={() => setOpenActive(!openActive)}>
                        <MaterialTypography
                            variant="subtitle2"
                            fontWeight="bold"
                        >
                            Active Status
                        </MaterialTypography>
                        <IconButton size="small">
                            <ExpandMore
                            sx={{
                                transform: openActive ? "rotate(180deg)" : "rotate(0deg)",
                                transition: "0.2s",
                            }}
                            />
                        </IconButton>
                    </MaterialBox>
                    <Collapse in={openActive}>
                        <MenuItem
                        disableRipple
                        sx={menuItemStyle}
                        onClick={() =>
                            handleChange({
                            target: { name: "isActive", value: true },
                            })
                        }>
                            <FormControlLabel
                            sx={{
                                m: 0,   
                                '& .MuiFormControlLabel-label': { fontSize: '0.8rem' },
                            }}
                            control={
                                <Checkbox
                                size="small"
                                checked={filterData.isActive === true}          
                                />
                            }
                            label="Active"
                            />
                        </MenuItem>
                        <MenuItem
                        disableRipple
                        sx={menuItemStyle}
                        onClick={() =>
                            handleChange({
                            target: { name: "isActive", value: false },
                            })
                        }>
                            <FormControlLabel
                            sx={labelStyle}
                            control={
                                <Checkbox
                                size="small"
                                checked={filterData.isActive === false}                   
                                />
                            }
                            label="Inactive"
                            />
                        </MenuItem>
                    </Collapse>
                </Grid2>
                <Grid2 size={{ xs: 12 }}>
                    <MaterialBox sx={sectionHeader} onClick={() => {
                            const nextState = !openCountry;
                            setOpenCountry(nextState);

                            if (nextState && countryOptions.length === 0) {
                                fetchCountryList();
                            }
                        }}>
                        <MaterialTypography
                        variant="subtitle2"
                        fontWeight="bold"
                        >
                        Country
                        </MaterialTypography>
                        <IconButton size="small">
                            <ExpandMore
                            sx={{
                                transform: openCountry ? "rotate(180deg)" : "rotate(0deg)",
                                transition: "0.2s",
                            }}
                            />
                        </IconButton>
                    </MaterialBox>
                        <Collapse in={openCountry}>                                            
                        {/* Dynamic Country List */}
                        {countryOptions?.map((country) => (
                        <MenuItem
                            disableRipple
                            sx={menuItemStyle}
                            key={country.value}
                            onClick={() =>
                            handleChange({
                                target: { name: "countryId", value: country.value },
                            })
                            }
                        >
                            <FormControlLabel
                            sx={labelStyle}
                            control={
                                <Checkbox
                                size="small"
                                checked={filterData.countryId === country.value}
                                />
                            }
                            label={country.label}
                            />
                        </MenuItem>
                        ))}
                        </Collapse>
                </Grid2>

            </Grid2>

        </MaterialBox>

        <Divider />

        {/* Apply button */}
        <MenuItem
        onClick={() => onApply()}
        disableRipple
        sx={{
            padding: "6px 16px", 
            width: "fit-content",
            minWidth: "0px",
            mx: "auto",  
            borderRadius: "6px",
            backgroundColor: "#bcc7e9",
            color: "white",
            display: "flex",
            justifyContent: "center",
            transition: "0.2s ease",

            "&:hover": {
            backgroundColor: "#93a6e8",
            }
        }}
        >
        <MaterialTypography variant="button" fontWeight="bold">
            APPLY FILTER
        </MaterialTypography>
        </MenuItem>
    </Menu>
  );
};

export default StateListFilterDialog;
